<template>
  <div>
    <div class="mb-4">
      МедТочка — это отличный инструмент, отвечающий высоким требованиям медицинских работников и пациентов!
    </div>
    <div class="mb-4">
      Я очень доволен работой данного программного обеспечения. Сложностей в работе для меня как врача и для
      специалистов, работающих в моей клинике, нет. Из удобств отдельно хочу отметить мгновенную загрузку
      заключения в приложение пациента, напоминание ему о предстоящей записи, а также возможность подгрузки
      анализов пациентом перед приёмом с помощью телефона. Ранее пациенты приносили на приём стопки бумаг,
      бессчётное количество своих анализов, которые требовалось перебрать, чтобы найти нужное, и при этом не
      запутаться в том, что уже посмотрел/скопировал.
    </div>
    <div>
      Сами пациенты дают положительную обратную связь по взаимодействию с программой. Говорят, что благодаря
      МедТочке их лечение всегда «в кармане»!
    </div>
  </div>
</template>
